import React, { useState, useEffect } from "react";
import ReactGA from "react-ga4";
import GameCanvas from "./components/GameCanvas";
import LandingPage from "./components/LandingPage";
import "./App.css";

// Initialize Google Analytics
ReactGA.initialize("G-0YZW54V776");

const AdSenseSlot = ({ adSlotId }) => {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error("AdSense Error:", e);
    }
  }, []);

  return (
    <ins className="adsbygoogle"
         style={{ display: 'block', width: '100%', height: '100%' }}
         data-ad-client="ca-pub-3290301398811360"
         data-ad-slot={adSlotId}
         data-ad-format="auto"
         data-full-width-responsive="true"></ins>
  );
};

function App() {
  const [isPlaying, setIsPlaying] = useState(false);
  const [gameStarted, setGameStarted] = useState(false);
  const [level, setLevel] = useState("Easy");
  const [sensitivity, setSensitivity] = useState("Fast");
  const [showSettings, setShowSettings] = useState(false);

  useEffect(() => {
    const handleGlobalClick = () => setShowSettings(false);
    if (showSettings) {
      window.addEventListener('click', handleGlobalClick);
    }
    return () => window.removeEventListener('click', handleGlobalClick);
  }, [showSettings]);

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname, title: isPlaying ? "Palm Pilot - Arena" : "Palm Pilot - Home" });
  }, [isPlaying]);

  const handleLaunchEngine = () => {
    setIsPlaying(true);
    setGameStarted(false);
    window.scrollTo(0, 0);
  };

  const handleBackToHome = () => {
    setIsPlaying(false);
    setGameStarted(false);
    window.scrollTo(0, 0);
  };

  const handleStartGame = () => {
    setGameStarted(true);
  };

  return (
    <div className="App">
      {!isPlaying ? (
        <LandingPage onStartGame={handleLaunchEngine} />
      ) : (
        <div className="app-layout">
          <aside className="ad-sidebar left">
            <div className="ad-slot">
              <span>Sponsored</span>
              <AdSenseSlot adSlotId="1234567890" />
            </div>
          </aside>

          <main className="game-main">
            <header className="game-header">
              <div className="header-brand">
                <button className="btn-home" onClick={handleBackToHome}>← HOME</button>
                <h1>PALM PILOT</h1>
              </div>
              
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div className={`level-badge level-${level.toLowerCase()}`}>
                   {level} SQUADRON
                </div>
                <button 
                  className="settings-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowSettings(!showSettings);
                  }} 
                >
                  ⚙️
                </button>
              </div>

              {showSettings && (
                <div className="settings-dropdown" onClick={(e) => e.stopPropagation()}>
                  <h3>Mission Parameters</h3>
                  <div className="setting-group">
                    <label>Sensor Sensitivity</label>
                    <div className="toggle-group">
                      {['Slow', 'Medium', 'Fast'].map(s => (
                        <button key={s} onClick={() => setSensitivity(s)} className={sensitivity === s ? 'active' : ''}>{s}</button>
                      ))}
                    </div>
                  </div>
                  <div style={{ paddingTop: '10px', display: 'flex', gap: '12px' }}>
                    <a href="/privacy.html" style={{ fontSize: '0.7rem', color: 'var(--text-muted)' }}>Privacy</a>
                    <a href="/terms.html" style={{ fontSize: '0.7rem', color: 'var(--text-muted)' }}>Terms</a>
                  </div>
                </div>
              )}
            </header>
            
            {!gameStarted ? (
              <div className="setup-screen">
                <h2>GAME SETUP</h2>
                <p>Calibrate your hand position and select mission speed.</p>
                
                <div className="control-group">
                  <div className="toggle-selector">
                    {['Slow', 'Medium', 'Fast'].map(s => (
                      <button 
                        key={s} 
                        onClick={() => setSensitivity(s)} 
                        className={sensitivity === s ? 'active' : ''}
                      >
                        {s.toUpperCase()}
                      </button>
                    ))}
                  </div>
                </div>

                <button className="btn-primary" onClick={handleStartGame}>
                  ENGAGE ENGINE
                </button>
              </div>
            ) : (
              <GameCanvas onLevelChange={setLevel} sensitivity={sensitivity} setSensitivity={setSensitivity} />
            )}
          </main>

          <aside className="ad-sidebar right">
            <div className="ad-slot">
              <span>Sponsored</span>
              <AdSenseSlot adSlotId="0987654321" />
            </div>
          </aside>
        </div>
      )}
    </div>
  );
}

export default App;
